import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';

import { DataContext } from '../../../init/getData';

import Select from 'react-select';
import { Switch, Button } from 'antd';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';


const ActionsPermission = (props) => {

  const { api, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const { showModal, toggleModal, refreshTable, tittle, idRow } = props;

  const { wareHouseData } = useContext(DataContext);

  const [loadingEffect, setLoadingEffect] = useState(false);   
  const [settings, setSettings] = useState({});

  useEffect(() => {
    setSettings(
      {
        viewAllSales: idRow.viewAllSales,
        allowDiscount: idRow.allowDiscount,
        allowedDiscount: idRow.allowedDiscount,
        allowEdit: idRow.allowEdit,
        allowCredit: idRow.allowCredit,
        allowDiscountChange: idRow.allowDiscountChange,
        allowQuantityChange: idRow.allowQuantityChange,
        allowNetPriceChange: idRow.allowNetPriceChange,
        discountLimit: idRow.discountLimit,
        itemsDiscountLimit: idRow.itemsDiscountLimit,
        editChart: idRow.editChart,


      }
    )
  }, [idRow]);

  const handleSubmit = async (e) => {
    setLoadingEffect(true);
    e.preventDefault();

    const id = idRow.id;

    let res = await api.post(`/role/editPermissions`, JSON.stringify({ id, settings }))
    if (res.data.status) {
      toast.success(res.data.message);
      refreshTable();
      toggleModal();
    }
    else {
      toast.error(res.data.message);
    }
    setLoadingEffect(false);
  }

  const handleChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  }



  return (
    <Modal show={showModal} backdrop="static" size='xl' onHide={toggleModal} >
      <Modal.Header style={{ background: "#23576a" }} className="modal-close-button" closeButton>
        <Modal.Title style={{ color: "white" }}>Actions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit} id='Form'>

          <Form.Group as={Row} className="mb-2">






            <Form style={{ width: '25%', marginLeft: '20px' }}>

              <h4 style={{ textAlign: 'left' }}>POS</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>



              <Row>
                <Col>
                  <Form.Label column md={9}>View All Sales</Form.Label>
                  <Switch defaultChecked onChange={(e) => handleChange('viewAllSales', e)} checked={settings?.viewAllSales} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Edit</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowEdit', e)} checked={settings?.allowEdit} />
                </Col>
              </Row>

              
              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Credit</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowCredit', e)} checked={settings?.allowCredit} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Discount</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowDiscount', e)} checked={settings?.allowDiscount} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Discount Change</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowDiscountChange', e)} checked={settings?.allowDiscountChange} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Quantity change</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowQuantityChange', e)} checked={settings?.allowQuantityChange} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Net Price change</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('allowNetPriceChange', e)} checked={settings?.allowNetPriceChange} />
                </Col>
              </Row>

              <Row>
                <Col>
                  <Form.Label column md={9}>Allow Edit Chart</Form.Label>
                  <Switch defaultCheck ed onChange={(e) => handleChange('editChart', e)} checked={settings?.editChart} />
                </Col>
              </Row>      

            <Row className="mb-2">
              <Col>
                <Form.Label column md={11}>Discount %</Form.Label>
              </Col>
              <Col>
                <Form.Control
                  type="number"
                  step="any"
                  value={settings?.discountLimit}
                  onChange={(e) => handleChange('discountLimit', e.target.value)}
                  required
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Label column md={11}>Items Discount Limit:</Form.Label>
              </Col>
              <Col>
                <Form.Control
                  type="number"
                  step="any"
                  value={settings?.itemsDiscountLimit}
                  onChange={(e) => handleChange('itemsDiscountLimit', e.target.value)}
                  required
                />
              </Col>
            </Row>





            </Form>




            {/* Cash Actions  */}
            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>New Sales Tab</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>




            </Form>

          </Form.Group>




          <div className="modal-footer">
            <Button type="primary" loading={loadingEffect} onClick={handleSubmit}
              style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>Save</Button>
          </div>

        </Form>
      </Modal.Body>
    </Modal>
  )
}


export default ActionsPermission;